import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';

const SUPPORT_MODES = [
  { value: 'FORMOSA_IM', label: '自建客服（Formosa IM）' },
  { value: 'THIRD_PARTY', label: '第三方／線下（CMS）' },
  { value: 'OFF', label: '全部關閉' },
];

const SUPPORT_MODE_HINTS = {
  FORMOSA_IM:
    '目前模式：自建客服。會員「客服中心」顯示即時對話；CMS「客服中心管理」列表前台隱藏（後台仍可編輯備切換）。',
  THIRD_PARTY:
    '目前模式：第三方／線下。會員「客服中心」顯示 CMS「客服中心管理」內容；自建 Session／工作台下線。',
  OFF:
    '目前模式：全部關閉。會員只見暫不服務圖（CMS 圖片設定）；自建與 CMS 列表皆不顯示。',
};

/**
 * CS20 P0：聊天／客服功能總開關（後台真源）。
 */
export default function ImFeatureSwitchPage() {
  const [chatEnabled, setChatEnabled] = useState(false);
  const [supportMode, setSupportMode] = useState('FORMOSA_IM');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [savedHint, setSavedHint] = useState('');

  async function load() {
    setLoading(true);
    setError('');
    try {
      const data = await adminApi.getImFeatureSwitch();
      setChatEnabled(!!data?.chatEnabled);
      setSupportMode(data?.supportMode || 'FORMOSA_IM');
    } catch (err) {
      setError(err.message || '載入失敗');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function onSave() {
    setSaving(true);
    setError('');
    setSavedHint('');
    try {
      const data = await adminApi.updateImFeatureSwitch({
        chatEnabled,
        supportMode,
      });
      setChatEnabled(!!data?.chatEnabled);
      setSupportMode(data?.supportMode || supportMode);
      setSavedHint('已儲存');
    } catch (err) {
      setError(err.message || '儲存失敗');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="page-card" style={{ maxWidth: 640, padding: 24 }}>
      <h2 style={{ marginTop: 0 }}>IM 功能開關</h2>

      {loading ? <p>載入中…</p> : null}
      {error ? <div className="form-error">{error}</div> : null}
      {savedHint ? <div style={{ color: '#059669', marginBottom: 12 }}>{savedHint}</div> : null}

      {!loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <input
              type="checkbox"
              checked={chatEnabled}
              onChange={(e) => setChatEnabled(e.target.checked)}
            />
            <span>
              <strong>聊天系統</strong>（社交 IM：好友／群／貼圖／FAB「聊」）
            </span>
          </label>

          <div>
            <div style={{ marginBottom: 8 }}>
              <strong>客服系統通道</strong>
            </div>
            {SUPPORT_MODES.map((m) => (
              <label key={m.value} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <input
                  type="radio"
                  name="supportMode"
                  value={m.value}
                  checked={supportMode === m.value}
                  onChange={() => setSupportMode(m.value)}
                />
                <span>{m.label}</span>
              </label>
            ))}
            <p
              style={{
                margin: '4px 0 0',
                padding: '10px 12px',
                background: '#f3f4f6',
                borderRadius: 6,
                color: '#4b5563',
                fontSize: 13,
                lineHeight: 1.5,
              }}
            >
              {SUPPORT_MODE_HINTS[supportMode] || SUPPORT_MODE_HINTS.FORMOSA_IM}
            </p>
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="btn btn-primary" disabled={saving} onClick={onSave}>
              {saving ? '儲存中…' : '儲存'}
            </button>
            <button type="button" className="btn" disabled={saving} onClick={load}>
              重新載入
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
